import React from "react";
import { motion } from "framer-motion";
import { fmtDate } from "@/lib/api";

export const InvoiceMeta = ({ creator, invoice, theme }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.45, delay: 0.08 }}
    className="mt-10 grid grid-cols-2 gap-6 text-sm"
  >
    <div>
      <div className={`${theme.sectionLabel} mb-1`}>From</div>
      <div className={theme.body}>{creator.business_name || creator.name}</div>
      <div className={`${theme.muted} text-xs`}>{creator.name}</div>
    </div>
    <div>
      <div className={`${theme.sectionLabel} mb-1`}>To</div>
      <div className={theme.body}>{invoice.client_name}</div>
      <div className={`${theme.muted} text-xs`}>{invoice.client_email}</div>
    </div>
    <div>
      <div className={`${theme.sectionLabel} mb-1`}>Due</div>
      <div className={`${theme.body} font-mono text-sm`}>{fmtDate(invoice.due_date)}</div>
    </div>
    <div>
      <div className={`${theme.sectionLabel} mb-1`}>Currency</div>
      <div className={`${theme.body} font-mono text-sm`}>{invoice.currency}</div>
    </div>
  </motion.div>
);
